import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { getFaireImageIdentifier, getSetOfImageIdentifiers } from "./getSetOfImageIdentifiers";
export var waitForImagesToLoad = function(targetElements, abortNotifier, onImageLoad, shouldIncludeAllImages) {
    var _getWindowOrThrow = getWindowOrThrow(), HTMLImageElement = _getWindowOrThrow.HTMLImageElement, performance = _getWindowOrThrow.performance;
    return new Promise(function(resolve) {
        var _getSetOfImageIdentifiers = getSetOfImageIdentifiers(targetElements, shouldIncludeAllImages), numImages = _getSetOfImageIdentifiers.numImages, pendingImageUrls = _getSetOfImageIdentifiers.pendingImageUrls;
        var lastImageLoadTime = performance.now();
        var totalVisibleImages = pendingImageUrls.size;
        var onLoadOrError = function(event) {
            var target = event.target;
            if (target instanceof HTMLImageElement) {
                var wasInSet = pendingImageUrls.delete(getFaireImageIdentifier(target));
                if (wasInSet) {
                    lastImageLoadTime = performance.now();
                }
            }
            onImageLoad === null || onImageLoad === void 0 ? void 0 : onImageLoad(pendingImageUrls.size, totalVisibleImages);
            if (pendingImageUrls.size === 0) {
                removeListeners();
                resolve({
                    numImages: numImages,
                    lastImageLoadTime: lastImageLoadTime
                });
            }
        };
        var removeListeners = function() {
            targetElements.forEach(function(element) {
                element.removeEventListener("load", onLoadOrError, {
                    capture: true
                });
                element.removeEventListener("error", onLoadOrError, {
                    capture: true
                });
            });
        };
        if (targetElements.length === 0 || pendingImageUrls.size === 0) {
            resolve({
                numImages: numImages,
                lastImageLoadTime: lastImageLoadTime
            });
            onImageLoad === null || onImageLoad === void 0 ? void 0 : onImageLoad(0, totalVisibleImages);
        } else {
            targetElements.forEach(function(element) {
                element.addEventListener("load", onLoadOrError, {
                    capture: true
                });
                element.addEventListener("error", onLoadOrError, {
                    capture: true
                });
            });
            abortNotifier === null || abortNotifier === void 0 ? void 0 : abortNotifier.addAbortListener(function() {
                removeListeners();
                resolve({
                    numImages: numImages,
                    lastImageLoadTime: lastImageLoadTime
                });
            });
        }
    });
};
